import { Component, Input } from '@angular/core';
import { PolicyDto } from '../../../../service/dto-insurance';
import { Router } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-policy-search-modal',
  standalone: false,
  templateUrl: './policy-search-modal.component.html',
  styleUrl: './policy-search-modal.component.scss'
})
export class PolicySearchModalComponent {
	@Input() searchPhrase!: string;
	@Input() policies?: PolicyDto[];

	constructor(private router: Router, private modalRef: NzModalRef) { }

	openPolicy(policy: PolicyDto) {
		this.router.navigate(['/policy', policy.id]);
		this.modalRef.destroy();
	}
}
